const BOOLEAN_TRUE = 'true';

export default {
  APP_ENV: process.env.VUE_APP_ENV,
  APP_BASE_URL: process.env.VUE_APP_BASE_URL,
  APP_CONTENT_URL: process.env.VUE_APP_CONTENT_URL || process.env.VUE_APP_BASE_URL,
  API_DEBUG: (process.env.VUE_APP_API_DEBUG === BOOLEAN_TRUE),
  LANGUAGES: process.env.VUE_APP_LANGUAGES.split(',').map(entry => String(entry).trim()),
  ANALYTICS_DEBUG: (process.env.VUE_APP_ANALYTICS_DEBUG === BOOLEAN_TRUE),
  ANALYTICS_VARIABLES: {
    ENTITY_NAME: process.env.VUE_APP_ANALYTICS_VARIABLE_ENTITY_NAME || null,
    ENTITY_PHASE: process.env.VUE_APP_ANALYTICS_VARIABLE_ENTITY_PHASE || null,
  },
};
